import styles from "./server_error.module.css";


export default function ServerError() {
    return (
        <div className={styles.server_error} draggable={false}>
            <img
                className={styles.image}
                draggable={false}
                alt={"500 Error"}
                src={"/resources/images/backgrounds/500.png"}
            />
        </div>
    )
}